// DrawerButton.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './DrawerButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * DrawerButton
 * 
 * Description
 *  
 * @returns {ReactNode} - DrawerButton.
 */
const DrawerButton = React.memo(({ isOpen, setIsOpen }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (

        <button
            className="drawer-button-container"
            type="button"
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isOpen}
            onClick={() => setIsOpen((prev) => !prev)}
        >
            <Icon
                iconKey="dehaze"
                width={30}
                height={30}
                color={theme.foreground}
            />

        </button>
    );

});

// Dev Tools
DrawerButton.displayName = 'DrawerButton';

export default DrawerButton;

